import { render } from "./addMarketplacesToProducts.vue?vue&type=template&id=2fc77bfc"
import script from "./addMarketplacesToProducts.vue?vue&type=script&lang=js"
export * from "./addMarketplacesToProducts.vue?vue&type=script&lang=js"

import "./addMarketplacesToProducts.vue?vue&type=style&index=0&id=2fc77bfc&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/sales-managment/modals/addMarketplacesToProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fc77bfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fc77bfc', __exports__)) {
    console.log('reload')
    api.reload('2fc77bfc', __exports__)
  }
  
  module.hot.accept("./addMarketplacesToProducts.vue?vue&type=template&id=2fc77bfc", () => {
    console.log('re-render')
    api.rerender('2fc77bfc', render)
  })

}


export default __exports__